import ApiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";

export default {
  namespaced: true,
  state: {
    dealData: {},
    showDealOfferModal: false,
    lottieJson: {},
    showLottie: false,
  },
  getters: {},
  mutations: {
    updateDealData(state, payload) {
      state.dealData = payload;
    },
    updateShowModalFlag(state, payload) {
      state.showDealOfferModal = payload;
    }
  },
  actions: {
    getLottie({commit, state}, payload) {
      ApiCalls.GET_LOTTIE_DATA({
        headers: Headers(),
        payload: payload
      })
      .then((res) => {
        if(res?.data) {
          state.lottieJson = res.data;
          state.showLottie = true;
        }
      }).catch(err => {
      })
    },
  }
}